<template>
  <export-pdf :loading="loading" filename="comparativo_clube" title="Comparativo Clube x Fora clube">
    <mf-pdf-item title="Faturamento" :name="$getLoggedUser().client">
      <div class="chart-container">
        <faturamento-chart :group-by.sync="groupBy" :loading="loading" :use-chart-type.sync="revenueChartType" is-pdf-content />
      </div>
    </mf-pdf-item>
    <mf-pdf-item title="Cupons" :name="$getLoggedUser().client">
      <div class="chart-container">
        <cupons-chart :group-by.sync="groupBy" :loading="loading" :use-chart-type.sync="couponsChartType" is-pdf-content />
      </div>
    </mf-pdf-item>
    <mf-pdf-item title="Ticket médio" :name="$getLoggedUser().client">
      <div class="chart-container">
        <ticket-medio-chart :group-by.sync="groupBy" :loading="loading" :use-chart-type.sync="ticketChartType" is-pdf-content />
      </div>
    </mf-pdf-item>
    <mf-pdf-item title="Média de itens na cesta" :name="$getLoggedUser().client">
      <div class="chart-container">
        <media-itens-cesta-chart :group-by.sync="groupBy" :loading="loading" :use-chart-type.sync="averageChartType" is-pdf-content />
      </div>
    </mf-pdf-item>
  </export-pdf>
</template>

<script>
import ExportPdf from '@/components/ExportPdf.vue'
import FaturamentoChart from '@/modules/clube/desempenho/views/pages/FaturamentoChart.vue'
import CuponsChart from '@/modules/clube/desempenho/views/pages/CuponsChart.vue'
import TicketMedioChart from '@/modules/clube/desempenho/views/pages/TicketMedioChart.vue'
import MediaItensCestaChart from '@/modules/clube/desempenho/views/pages/MediaItensCestaChart.vue'
export default {
  name: 'ClubComparisonPdf',
  components: {
    ExportPdf,
    FaturamentoChart,
    CuponsChart,
    TicketMedioChart,
    MediaItensCestaChart,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    groupBy: {
      type: String,
      default: '',
    },
    revenueChartType: {
      type: String,
      default: 'bar',
    },
    couponsChartType: {
      type: String,
      default: 'bar',
    },
    ticketChartType: {
      type: String,
      default: 'bar',
    },
    averageChartType: {
      type: String,
      default: 'bar',
    },
  },
  computed: {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.chart-container {
  width: 95%;
  margin: 0 auto;
}
</style>
